// extracted by css-extract-rspack-plugin
export default {"sidebarNavItem":"TixroODFoGgp9e5H"};